import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../services/AuthContext";
import PreviousPage from "./components/PreviousPage";
import CreatePostForm from "./components/CreatePostForm";
import axios from "axios";
import { useParams } from "react-router-dom";
import Sorting from "../services/Sorting";
import likeStyles from "../styles/Like.module.css";
import styles from "../styles/UserProfile.module.css";
import { toast } from "react-toastify";
import Menu from "./components/Menu";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"; // Importazione di FontAwesomeIcon
import {
  faTrash,
  faSortUp,
  faSortDown,
  faSignOutAlt,
  faCalendarAlt,
  faArrowLeft,
  faComment,
} from "@fortawesome/free-solid-svg-icons"; // Importazione delle icone
import Like from "./components/Like";
import { MdOutlineInsertComment } from "react-icons/md";
import { useNavigate } from "react-router-dom";

function UserProfile() {
  const [menu, setMenu] = useState("show");
  const { login, setLogin } = useContext(AuthContext);
  const [order, setOrder] = useState("newest");
  const [posts, setPosts] = useState([]);
  const { username } = useParams();
  const [visibleCommentsPostId, setVisibleCommentsPostId] = useState(null); // Stato per memorizzare l'ID del post con i commenti visibili
  const navigate = useNavigate();

  // Funzione per ordinare i post dal più recente
  const sortNew = () => {
    let ordered = Sorting.sortPosts("newest", [...posts]);
    setOrder("newest");
    setPosts(ordered);
  };

  // Funzione per ordinare i post dal più vecchio
  const sortOld = () => {
    let ordered = Sorting.sortPosts("oldest", [...posts]);
    setOrder("oldest");
    setPosts(ordered);
  };

  // Funzione per alternare la visibilità dei commenti per un singolo post
  const toggleComments = (postId) => {
    if (visibleCommentsPostId === postId) {
      setVisibleCommentsPostId(null); // Se i commenti sono già visibili per questo post, li nasconde
    } else {
      setVisibleCommentsPostId(postId); // Mostra i commenti solo per il post selezionato
    }
  };

  // Funzione di logout
  const onLogOut = () => {
    localStorage.removeItem("AuthToken");
    navigate("/entry");
  };

  // Funzione per cancellare un post
  const onDelete = async (id) => {
    const conferma = window.confirm("Sei sicuro di voler cancellare il post?");
    if (conferma) {
      let response = await axios.delete(
        process.env.REACT_APP_SERVER_URL + "posts/${id}",
        {
          headers: {
            authToken: localStorage.getItem("AuthToken"),
          },
        }
      );

      toast.success("Post cancellato!", {
        onClose: () => {
          setPosts(posts.filter((post) => post.id !== id));
        },
        autoClose: 3000,
      });
    }
  };

  // Funzione per ottenere i post dell'utente
  const fetchData = async () => {
    try {
      let response = await axios.get(
        process.env.REACT_APP_SERVER_URL + "posts/${username}",
        {
          headers: {
            authToken: localStorage.getItem("AuthToken"),
          },
        }
      );
      setPosts(Sorting.sortPosts(order, response.data));
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  // Effetto per ottenere i dati quando cambia username o order
  useEffect(() => {
    fetchData();
  }, [username, order]);

  return (
    <div className={styles.contents}>
      <div className={styles.header}>
        <Menu setMenu={setMenu} onLogOut={onLogOut} />

        {menu === "show" ? <PreviousPage /> : <CreatePostForm />}

        <div className={styles.pageTitle}>
          <h1>POSTS</h1>
          {posts.length > 0 && <h2>{posts[0]?.user?.username}</h2>}
          <div className={styles.buttoncontainer}>
            <p>
              <button type="button" onClick={sortNew}>
                <FontAwesomeIcon
                  icon={faSortUp}
                  style={{
                    color: order === "newest" ? "gray" : "white",
                    fontSize: "24px",
                  }}
                />
                <FontAwesomeIcon
                  icon={faCalendarAlt}
                  style={{
                    color: order === "newest" ? "gray" : "white",
                    fontSize: "24px",
                  }}
                />
              </button>
            </p>
            <p>
              <button type="button" onClick={sortOld}>
                <FontAwesomeIcon
                  icon={faCalendarAlt}
                  style={{
                    color: order === "oldest" ? "gray" : "white",
                    fontSize: "24px",
                  }}
                />

                <FontAwesomeIcon
                  icon={faSortDown}
                  style={{
                    color: order === "oldest" ? "gray" : "white",
                    fontSize: "24px",
                  }}
                />
              </button>
            </p>
          </div>
        </div>
      </div>

      <div className={styles.container}>
        {posts.length > 0 ? (
          posts.map((post) => {
            const isOwner = post?.user?.username === login?.username;
            const userLike =
              post.likes && post.likes.length > 0 ? post.likes[0].like : false;

            return (
              <div className={styles.post} key={post.id}>
                <p>{post?.title}</p>
                <p>{post?.post}</p>
                <p>
                  Created:{" "}
                  {new Date(post.createdAt)
                    .toLocaleString("it-IT", {
                      day: "2-digit",
                      month: "2-digit",
                      year: "numeric",
                      hour: "2-digit",
                      minute: "2-digit",
                    })
                    .replace(",", " at")}
                </p>
                {isOwner && (
                  <p>
                    <div className={likeStyles.like}>
                      <div className={likeStyles.numlike}>
                        <button type="button" onClick={() => onDelete(post.id)}>
                          <FontAwesomeIcon icon={faTrash} />
                        </button>{" "}
                        <button
                          type="button"
                          onClick={() => toggleComments(post.id)} // Al clic, mostra o nasconde i commenti solo per quel post
                          title="Show/Hide Comments"
                        >
                          <FontAwesomeIcon icon={faComment} />
                          {/* Mostra il numero di commenti accanto all'icona */}
                          <span style={{ marginLeft: "5px" }}>
                            {post.commentsCount || 0}
                          </span>
                        </button>
                        <Like postId={post.id} userLike={userLike} />{" "}
                        {/* Passa il like */}
                      </div>
                    </div>
                  </p>
                )}
              </div>
            );
          })
        ) : (
          <p>No posts available</p>
        )}
      </div>
    </div>
  );
}

export default UserProfile;
